export const FtpConfigFieldMapping = {
  //setup
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIAN: 'technician',
  TECHINICIANID: 'technicianId',
  COMMENTS:'comments',
  ENGINE_A_INFO: 'engine-a-info',
  ENGINE_B_INFO: 'engine-b-info',
  TEST_MODE: 'mode',
  DIRECTION: 'direction',
  TEST_TYPE: 'type',
  TCP_PORT: 'tcp-port',
  THRESHOLD_ENABLED: 'threshold-enabled',
  ENGINE_A_TO_B_THRESHOLD: 'engine-a-to-b-threshold',
  ENGINE_B_TO_A_THRESHOLD: 'engine-b-to-a-threshold',
  TARGET_ENABLED: 'target-enabled',
  ENGINE_A_TO_B_TARGET: 'engine-a-to-b-target',
  ENGINE_B_TO_A_TARGET: 'engine-b-to-a-target',
  ENGINE_A_TO_B_URL: 'engine-a-to-b-url',
  ENGINE_B_TO_A_URL: 'engine-b-to-a-url',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',
  SCHEDULER: 'scheduler'
};

export const TEST_DURATIONS = [
  { name: '1 minute', value: 60 },
  { name: '15 minutes', value: 900 },
  { name: '2 Hours', value: 7200 },
  { name: '24 Hours', value: 86400 },
  { name: 'User Defined', value: 'custom' }
];

export enum streamRateConventionLabel {
  L1 = 'L1 Mbps (ULR)',
  L2 = 'L2 Mbps (IR)'
}

export enum streamRateConventionValue {
  L1 = 'l1-mbps',
  L2 = 'l2-mbps'
}

export enum testTypeValue {
  FTP = 'ftp'
}

export enum testTypeLabel {
  FTP = 'FTP'
}

export const TEST_TYPE = [{ name: testTypeLabel.FTP, value: testTypeValue.FTP }];
